import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=cef08c6a&scoped=true&"
import script from "./InputTel.ts?vue&type=script&lang=ts&"
export * from "./InputTel.ts?vue&type=script&lang=ts&"
import style0 from "./InputTel.scss?vue&type=style&index=0&id=cef08c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef08c6a",
  null
  
)

export default component.exports